(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["swym-wishlist-styles"] && !Shopify.designMode) return;
  try {
    // Transicao de saida do popup do Wishlist Plus. O app esconde a janela na hora;
  // aqui a gente segura o clique de fechar por 180ms, anima, e repassa o clique.
  (function () {
    var DURACAO = 180;
    var repassando = false;

    function conteudo() {
      var el = document.querySelector('.swym-modal-content');
      return el && el.offsetWidth ? el : null;
    }

    function animarEDepois(fn) {
      var el = conteudo();
      if (!el || repassando) { fn(); return; }
      var reduzir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduzir) { fn(); return; }
      el.classList.add('swym-tw-saindo');
      repassando = true;
      setTimeout(function () {
        try { fn(); } finally {
          setTimeout(function () { el.classList.remove('swym-tw-saindo'); repassando = false; }, 50);
        }
      }, DURACAO);
    }

    document.addEventListener('click', function (ev) {
      if (repassando) return;
      var alvo = ev.target && ev.target.closest ? ev.target : null;
      if (!alvo) return;
      var btn = alvo.closest('.swym-close-btn');
      var modal = alvo.closest('.swym-modal');
      var dentro = alvo.closest('.swym-modal-content');
      var fecharPeloFundo = modal && !dentro && conteudo();
      if (!btn && !fecharPeloFundo) return;
      ev.stopImmediatePropagation();
      ev.preventDefault();
      var repassar = btn || alvo;
      animarEDepois(function () { repassar.click(); });
    }, true);

    document.addEventListener('keydown', function (ev) {
      if (repassando || ev.key !== 'Escape' || !conteudo()) return;
      ev.stopImmediatePropagation();
      ev.preventDefault();
      animarEDepois(function () {
        document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27, which: 27, bubbles: true }));
      });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
